import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function SectionHeader({
  overline,
  title,
  subtitle,
  align = "left",
  link,
  linkLabel = "View all",
  testId,
}) {
  const isCenter = align === "center";
  return (
    <div
      data-testid={testId}
      className={`mb-16 flex flex-col ${isCenter ? "items-center text-center" : "items-start"} gap-5`}
    >
      {overline && <span className="overline">{overline}</span>}
      <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight max-w-3xl leading-[1.05]">
        {title}
      </h2>
      {subtitle && (
        <p className="text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">
          {subtitle}
        </p>
      )}
      {link && (
        <Link
          to={link}
          className="inline-flex items-center gap-2 text-[#D4AF37] text-sm uppercase tracking-[0.18em] hover:text-[#F0C84B] mt-2"
        >
          {linkLabel} <ArrowUpRight size={16} />
        </Link>
      )}
    </div>
  );
}
